'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
var $d_Lpresto_AgentView$ReceiveProtocol = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i(1, "presto.AgentView$ReceiveProtocol", ({
  b5: 1
}));
export { $d_Lpresto_AgentView$ReceiveProtocol as $d_Lpresto_AgentView$ReceiveProtocol };
//# sourceMappingURL=presto.-Agent-View$-Receive-Protocol.js.map
